import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppFab } from "./WhatsAppFab";
import { FloatingMotifs } from "./Motifs";

export function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}

export function PageHero({ eyebrow, title, children }) {
  return (
    <section className="relative bg-bej-light paper-grain overflow-hidden">
      <FloatingMotifs />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 sm:py-20">
        {eyebrow && <p className="rise text-sm font-bold uppercase tracking-[0.2em] text-navy/60 mb-3">{eyebrow}</p>}
        <h1 className="rise font-heading text-4xl sm:text-5xl font-black text-navy tracking-tight max-w-3xl" data-testid="page-title">
          {title}
        </h1>
        {children && <div className="rise mt-5 max-w-2xl text-base sm:text-lg text-slate-700 leading-relaxed [animation-delay:120ms]">{children}</div>}
      </div>
    </section>
  );
}
